import { epicRequest } from 'app'
import { trackEvent } from 'global-utils/Analytics'
import storage from 'global-utils/Storage'
import System from 'system'

import VerifyRegistrationCode from 'components/ui/VerifyRegistrationCode'

import { authLoginByNetwork } from './AuthActions'
import { SYSTEM_MESSAGE_INITIAL_STATE, systemMessageShow } from './SystemMessageActions'

export const USER_REGISTER = 'USER_REGISTER'
export const USER_REGISTER_FULFILLED = 'USER_REGISTER_FULFILLED'
export const USER_REGISTER_ERROR = 'USER_REGISTER_ERROR'
export const USER_REGISTER_CANCELED = 'USER_REGISTER_CANCELED'

export const USER_REGISTER_INITIAL_STATE = {
  error: null,
  usr: null,
}

export const userRegister = (payload) => ({
  payload: {
    ...payload,
    client_id: System.env.client.id,
    client_secret: System.env.client.secret,
  },
  type: USER_REGISTER,
})
export const userRegisterFulfilled = (payload) => {
  trackEvent('Authentication', 'Signup', 'Done')
  return {
    payload,
    type: USER_REGISTER_FULFILLED,
  }
}
export const userRegisterCanceled = () => ({
  payload: null,
  type: USER_REGISTER_CANCELED,
})
export const userRegisterError = (payload) => {
  trackEvent('Authentication', 'Signup', 'Error')
  return {
    payload,
    type: USER_REGISTER_ERROR,
  }
}

export const userRegisterEpic = epicRequest({
  actionType: USER_REGISTER,
  errorAction: userRegisterError,
  fulfilledAction: userRegisterFulfilled,
  maps: [
    (response, action) => {
      const user = response.response.data[0]
      if (!user.is_verified || !user.provider) {
        if (window.fbq) {
          window.fbq('track', 'CompleteRegistration')
        }
        return systemMessageShow({
          ...SYSTEM_MESSAGE_INITIAL_STATE,
          msg: <VerifyRegistrationCode data={action.payload} />,
          options: [],
          title: 'Confirma tu correo',
        })
      }

      return authLoginByNetwork(
        user.provider.network,
        user.provider.access_token,
        !!storage.getFlashed('rememberAccess'),
      )
    },
  ],
  request: ({ payload }) => ({
    body: payload,
    method: 'post',
    url: 'auth/register',
  }),
  untilTypes: USER_REGISTER_CANCELED,
})
